import type { LocationState, Path, Location } from "history";

import historyInstance from "./history";


// Navigates to the specified path using history.push.
export function push(path: Path | Location, state?: LocationState): void {
  if (typeof path === "string") {
    historyInstance.push(path, state);
  }
  else {
    historyInstance.push(path);
  }
}

// Navigates to the specified path using history.replace.
export function replace(path: Path | Location, state?: LocationState): void {
  if (typeof path === "string") {
    historyInstance.replace(path, state);
  }
  else {
    historyInstance.replace(path);
  }
}

// Navigates back one entry in the history stack.
export function goBack(): void {
  historyInstance.goBack();
}

// Navigates forward one entry in the history stack.
export function goForward(): void {
  historyInstance.goForward();
}

// Navigates to a specific entry in the history stack.
export function go(n: number): void {
  historyInstance.go(n);
}
